import React from "react";
import GeneralStrings from "../../strings/GeneralStrings.json";
import { getCurrentYear } from "../../utilities/DateHelper.js";
import "./Footer.scss";
import RoutesConst from "../../consts/RoutesConst.js";
import termsConditions from "../../assets/pdfs/terms-conditions.pdf";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-links">
        <a href={termsConditions} target="_blank" rel="noreferrer">
          Terms & Conditions
        </a>
        <a href={RoutesConst.PRIVACY_POLICY}>Privacy Policy</a>
      </div>
      <hr />
      <div className="copyright">
        <span> © {getCurrentYear()} </span>
        <span
          dangerouslySetInnerHTML={{ __html: GeneralStrings.FOOTER_HTML }}
        />
      </div>
    </footer>
  );
};

export default Footer;
